import DOMPurify from 'dompurify';

export default {
    methods: {
        printHtml(htmlString, header = '', pageTitle = ' ') {
            let printIframe = document.getElementById('print-iframe');
            if (printIframe) {
                printIframe.remove();
            }

            printIframe = document.createElement('iframe');
            printIframe.id = 'print-iframe';
            printIframe.name = 'print-iframe';
            printIframe.style.visibility = 'hidden';
            printIframe.style.position = 'absolute';

            printIframe.onload = () => {
                let title = document.createElement('title');
                title.innerText = pageTitle;
                printIframe.contentDocument.head.appendChild(title);

                // Inherit CSS from parent document
                const links = document.head.querySelectorAll('link[rel="stylesheet"]');
                for (const link of links) {
                    if (link.hasAttribute('href')) {
                        let newLink = document.createElement('link');
                        newLink.type = 'text/css';
                        newLink.rel = 'stylesheet';
                        newLink.href = link.getAttribute('href');
                        newLink.media = link.getAttribute('media') ?? 'all';

                        if (link.getAttribute('integrity')) {
                            newLink.integrity = link.getAttribute('integrity');
                        }

                        if (link.getAttribute('crossorigin')) {
                            newLink.crossorigin = link.getAttribute('crossorigin');
                        }

                        printIframe.contentDocument.head.appendChild(newLink);
                    }
                }

                // Inherit styles from parent document
                const styles = document.head.querySelectorAll('style');
                for (const style of styles) {
                    let newStyle = document.createElement('style');
                    newStyle.innerHTML = style.innerHTML;

                    printIframe.contentDocument.head.appendChild(newStyle);
                }

                printIframe.contentDocument.body.innerHTML = DOMPurify.sanitize(header);

                printIframe.contentDocument.body.innerHTML += DOMPurify.sanitize(htmlString.trim());

                setTimeout(() => {
                    printIframe.contentWindow.focus();
                    printIframe.contentWindow.print();
                }, 1000);
            };

            document.body.appendChild(printIframe);
        },
    }
}